import React from "react"
import autobind from "class-autobind"
import CircularProgress from "material-ui/CircularProgress"
import { ITimecardDay, IBreadCrumbDocument, IMapMarker, IGPSPoint } from "../../../models"
import * as api from "../../../api"
import strings from "../../../localization/strings"
import { InfoWindow, GoogleMapLoader, GoogleMap, Marker, Polyline } from "react-google-maps"
import { triggerEvent } from "react-google-maps/lib/utils"
import JSONbig from 'json-bigint'
import { purple900 } from "material-ui/styles/colors"
import moment from "moment"
import ClientLocalDateTimeStr from "../../common/ClientLocalDateTimeStr"
import * as timeHelper from "../../../helpers/timeHelper"

interface IProps {
    objectId: string
    dayData: ITimecardDay
}
interface IState {
    loading: boolean
    markers: IMapMarker[]
    paths: IGPSPoint[][]
}

export default class BreadCrumbDrawerContent extends React.Component<IProps, IState> {
    private setBounds
    private _googleMapComponent
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            markers: [],
            paths: []
        }
        this.setBounds = true
        autobind(this)
    }

    componentDidMount() {
        this.loadData()
    }

    componentWillReceiveProps(nextProps: IProps) {
        nextProps.dayData.LocalStartDayTime !== this.props.dayData.LocalStartDayTime &&
            this.loadData()
    }

    loadData() {
        this.setState({ loading: true }, () =>
            api.getBreadCrumbData(this.props.objectId, this.props.dayData.LocalStartDayTime, this.props.dayData.LocalEndDayTime).then(res => {
                const result = res.data as IBreadCrumbDocument[]
                this.setState({ loading: false }, () =>
                    this.getMapMarkers(result)
                )
            })
        )
    }

    getMapMarkers(breadCrumbDocs: IBreadCrumbDocument[]): IMapMarker[] {
        if (!breadCrumbDocs || breadCrumbDocs.length === 0) return []

        const markers: IMapMarker[] = []
        const bounds = new google.maps.LatLngBounds()
        const paths: IGPSPoint[][] = []
        breadCrumbDocs.forEach(breadCrumbDoc => {
            if (breadCrumbDoc.BreadCrumbInfo.GPSWayPoints) {
                const path: IGPSPoint[] = []
                breadCrumbDoc.BreadCrumbInfo.GPSWayPoints.forEach(point => {
                    if (point.Location) {
                        const lat = typeof point.Location.Latitude === "object" ? Number(JSONbig.stringify(point.Location.Latitude)) : point.Location.Latitude
                        const lng = typeof point.Location.Longitude === "object" ? Number(JSONbig.stringify(point.Location.Longitude)) : point.Location.Longitude

                        if (lat !== 0 && lng !== 0) {
                            const GPSpoint: IGPSPoint = { lat, lng }
                            const punchMarker = {
                                position: GPSpoint,
                                hierarchyId: breadCrumbDoc.HierarchyId,
                                icon: `/assets/markers/location-pin-${point.Speed > 20 ? "green" : point.Speed > 5 ? "yellow" : "red"}.png`,
                                GPSWayPoint: point
                            } as IMapMarker
                            markers.push(punchMarker)
                            bounds.extend(new google.maps.LatLng(lat, lng))
                            path.push(GPSpoint)
                        }
                    }
                })

                path.length > 0 &&
                    paths.push(path)
            }
        })

        if (this.setBounds) {
            if (this._googleMapComponent) {
                triggerEvent(this._googleMapComponent, "resize")
                if (markers && markers.length > 0) {
                    this._googleMapComponent.fitBounds(bounds)
                    this.setBounds = false
                }
            }
        }
        this.setState({ markers, paths })
    }

    handleMarkerMouseOver(index) {
        this.state.markers[index].showInfoWindow = true
        this.setState({ markers: this.state.markers })
    }

    handleMarkerClose(index) {
        this.state.markers[index].showInfoWindow = false
        this.setState({ markers: this.state.markers })
    }

    render() {
        const breadCrumbExist = this.state.markers.length > 0
        return (
            <div style={{ textAlign: "center" }}>
                {this.state.loading &&
                    <div style={{ marginTop: 60 }}>
                        <CircularProgress />
                    </div>
                }
                {!this.state.loading && !breadCrumbExist &&
                    <h2 style={{ marginTop: 60 }}>{strings.No_Breadcrumb}</h2>
                }
                <GoogleMapLoader
                    containerElement={<div className="google-map-loader-custom" style={{ width: "100%", height: "calc(100vh - 140px)", display: (this.state.loading || !breadCrumbExist) && "none" }} />}
                    googleMapElement={
                        <GoogleMap ref={map => this._googleMapComponent = map} defaultZoom={4}>
                            {this.state.markers &&
                                this.state.markers.map((marker, index) =>
                                    <Marker
                                        key={index}
                                        {...marker}
                                        onMouseover={() => this.handleMarkerMouseOver(index)}
                                        onMouseout={() => this.handleMarkerClose(index)}
                                    >
                                        {marker.showInfoWindow &&
                                            <InfoWindow
                                                onCloseClick={() => this.handleMarkerClose(index)}
                                            >
                                                <div>
                                                    <h4>
                                                        {moment(timeHelper.keepConvertUTCToLocal(marker.record.PunchTimeLocal)).format("h:mm a")}
                                                    </h4>
                                                    <div style={{ textAlign: "left" }}>
                                                        {marker.GPSWayPoint.Speed !== -1 &&
                                                            <div>
                                                                {`${strings.Speed}: ${marker.GPSWayPoint.Speed} km/h`}
                                                            </div>
                                                        }
                                                        {marker.GPSWayPoint.Accuracy &&
                                                            <div>
                                                                {`${strings.Accuracy}: ${marker.GPSWayPoint.Accuracy}`}
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </InfoWindow>
                                        }
                                    </Marker>
                                )
                            }
                            {this.state.paths &&
                                this.state.paths.map((path, index) =>
                                    <Polyline
                                        key={index}
                                        path={path}
                                        options={{
                                            strokeColor: purple900,
                                            strokeWeight: 2
                                        }}
                                    />
                                )}
                        </GoogleMap>
                    }
                />
            </div>
        )
    }
}